import {
    TermFlagBadge,
    TermListWrapper,
    TermPhrase,
    TermRow,
} from './TermComponents';
import { TERM_TYPES } from './termTypes';
import DownloadButton from '../Button/DownloadButton';
import Keywords from '../Keywords';
import Loading from '../Loading';
import { Select } from '../Input';
import { SoftButton } from '../Button';
import Stack from '../Stack';
import VertLine from '../VertLine';
import { useState } from 'react';

// Hiding is one-of, so both types can never be hidden at once.
const termTypeOptions = [
    { label: 'All', value: 'all', hiddenTermType: null },
    {
        label: 'Keywords',
        value: 'keywords',
        hiddenTermType: TERM_TYPES.HASHTAG,
    },
    {
        label: 'Hashtags',
        value: 'hashtags',
        hiddenTermType: TERM_TYPES.KEYWORD,
    },
];

function TopPhrasesSection({
    paginateBy,
    data,
    isLoading,
    sortedData,
    dataReady,
    showTranslations,
    handleDownload,
    mixpanelMeta,
    name,
    WrapperComponent,
    HeadingComponent,
    NoDataComponent,
    displayQty = 5,
    showIcon = false,
    showMoreLabel,
    canFilterTermTypes = false,
    ...props
}) {
    const [translationLanguage, setTranslationLanguage] = useState(null);
    const [termTypeOption, setTermTypeOption] = useState(termTypeOptions[0]);
    const hiddenTermType = canFilterTermTypes
        ? termTypeOption.hiddenTermType
        : null;
    const visiblePhrases = hiddenTermType
        ? (sortedData || []).filter(({ type }) => type !== hiddenTermType)
        : sortedData;
    const keywordsKey = Object.values(data || {})
        .flat()
        .sort()
        .join('-');

    return (
        <WrapperComponent {...props}>
            <HeadingComponent name={name} data={data} showIcon={showIcon}>
                <Stack
                    $space=".375rem"
                    $direction="row"
                    $wrap="false"
                    css={`
                        display: inline-flex;
                        align-items: center;
                        margin-left: auto;
                    `}
                >
                    {canFilterTermTypes ? (
                        <>
                            <Select
                                onChange={(selected) =>
                                    setTermTypeOption(selected)
                                }
                                value={termTypeOption}
                                options={termTypeOptions}
                                $menuAlign="left"
                                buttonProps={{
                                    as: SoftButton,
                                    selectLabel: 'Show',
                                    size: 'sm',
                                }}
                                mixpanelContext="TermTypeFilterSelect"
                                mixpanelMeta={mixpanelMeta}
                                handleMixpanelEvent={({ value }) => ({ value })}
                                week={data?.week}
                                year={data?.year}
                            />
                            <VertLine />
                        </>
                    ) : null}
                    {showTranslations ? (
                        <>
                            <SoftButton
                                mixpanelContext="TranslateButton"
                                onClick={() => {
                                    setTranslationLanguage(
                                        (translationLanguage) =>
                                            translationLanguage ? null : 'en',
                                    );
                                }}
                            >
                                {!translationLanguage
                                    ? 'Show Translations'
                                    : 'Hide Translations'}
                            </SoftButton>
                            <VertLine />
                        </>
                    ) : null}
                    <DownloadButton
                        disabled={!dataReady}
                        fetching={isLoading}
                        onClick={() => handleDownload(visiblePhrases)}
                        mixpanelMeta={{ contentKey: 'TopKeywords' }}
                    />
                </Stack>
            </HeadingComponent>
            {visiblePhrases && visiblePhrases.length ? (
                <Keywords
                    paginateBy={paginateBy}
                    phrases={visiblePhrases}
                    data={data}
                    highlight={name}
                    displayQty={displayQty}
                    translationLanguage={
                        showTranslations ? translationLanguage : null
                    }
                    key={keywordsKey}
                    showMoreLabel={showMoreLabel}
                    KeywordPhraseComponent={TermPhrase}
                    WrapperComponent={TermListWrapper}
                    KeywordWrapperComponent={TermRow}
                    KeywordFlagWrapperComponent={TermFlagBadge}
                />
            ) : isLoading ? (
                <Loading />
            ) : (
                <NoDataComponent />
            )}
        </WrapperComponent>
    );
}

export default TopPhrasesSection;
